module.exports = __webpack_public_path__ + "media/original.e6ba8203.mp4";